import {makeObservable, observable} from 'mobx';

import {history, socketStore, generalStore} from '../index';
import {routes} from '../App';

const RING_WATCHDOG_MS = 3000;

const buildSupportRoomPath = (roomIdentifier, password) => routes.OPEN_SUPPORT_ROOM_WITH_PASSWORD
    .replace(':roomId', roomIdentifier)
    .replace(':password', password);

export class IncomingCallStore {
    currentCall = null;
    dismissedRoomIds = new Set();
    lastRingAt = new Map();
    watchdogTimerId = null;

    constructor() {
        makeObservable(this, {
            currentCall: observable,
        });
    }

    showIncomingCall = (payload) => {
        if (!payload?.room?.RoomIdentifier) return;
        const roomId = payload.room.RoomIdentifier;
        const now = Date.now();
        const isNewSequence = now - (this.lastRingAt.get(roomId) ?? 0) > RING_WATCHDOG_MS;
        this.lastRingAt.set(roomId, now);
        if (isNewSequence) this.dismissedRoomIds.delete(roomId);

        if (this.dismissedRoomIds.has(roomId)) return;

        const sameCall = this.currentCall?.room?.RoomIdentifier === roomId;
        if (!sameCall) {
            this.currentCall = payload;
        }
        this.armRingWatchdog();
    };

    armRingWatchdog = () => {
        if (this.watchdogTimerId) clearTimeout(this.watchdogTimerId);
        this.watchdogTimerId = setTimeout(this.handleRingStopped, RING_WATCHDOG_MS);
    };

    handleRingStopped = () => {
        this.watchdogTimerId = null;
        this.currentCall = null;
    };

    cancelRingWatchdog = () => {
        if (this.watchdogTimerId) {
            clearTimeout(this.watchdogTimerId);
            this.watchdogTimerId = null;
        }
    };

    decline = () => {
        if (!this.currentCall) return;
        const {caller, room} = this.currentCall;
        socketStore.respondToCall(caller?.DeviceGuid, false, generalStore.userDetails);
        this.dismissedRoomIds.add(room.RoomIdentifier);
        this.cancelRingWatchdog();
        this.currentCall = null;
    };

    accept = () => {
        if (!this.currentCall) return;
        const {caller, room} = this.currentCall;
        socketStore.respondToCall(caller?.DeviceGuid, true, generalStore.userDetails);
        this.dismissedRoomIds.add(room.RoomIdentifier);
        this.cancelRingWatchdog();
        this.currentCall = null;
        if (room.RoomIdentifier && room.Password) {
            history.push(buildSupportRoomPath(room.RoomIdentifier, room.Password));
        }
    };

    clear = () => {
        this.cancelRingWatchdog();
        this.currentCall = null;
    };

    reset = () => {
        this.cancelRingWatchdog();
        this.currentCall = null;
        this.dismissedRoomIds.clear();
        this.lastRingAt.clear();
    };
}
